import axios from "axios"

/**
 * « Modifier mes créneaux » (espace parent, jeton de l'élève). Sans `live_session_ids` : les cours de
 * la semaine. Avec : en plus les places chez leurs tuteurs, la grille colorée et le repli à
 * demander. Les ids passent par les paramètres d'URL : c'est la clé que le parcours compare à la
 * réponse (`useApiFetch` → `scopeUrlParams`).
 */
function getStudentSlotChange({}, {}, params) {
    return axios.get(`api/v1/student-slot-change`, { params })
}

/** La demande « Modifier mes créneaux » en cours, ou `pending: null` : l'accueil et le portail la suivent. */
function getPendingStudentSlotChange() {
    return axios.get(`api/v1/student-slot-change/pending`)
}

/**
 * `{ live_session_ids, seats? }` (une place pour chaque cours) ou
 * `{ live_session_ids, slots, fallbacks? }` (les horaires proposés aux tuteurs).
 */
function submitStudentSlotChange({}, data) {
    return axios.post(`api/v1/student-slot-change`, data)
}

export const studentSlotChangeService = {
    getStudentSlotChange,
    getPendingStudentSlotChange,
    submitStudentSlotChange,
}
